import { render, staticRenderFns } from "./SetupToolsBar.vue?vue&type=template&id=00aac688"
import script from "./SetupToolsBar.vue?vue&type=script&lang=js"
export * from "./SetupToolsBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports